import React from 'react';
import { GoogleMap } from '@react-google-maps/api';
import grey from '@material-ui/core/colors/grey';
import MapContent from './MapContent';
import { Box } from 'home/useBoxes';

// Japan bounds
const restrictionBounds: google.maps.LatLngBoundsLiteral = {
  north: 46.45673,
  south: 23.924618,
  east: 151.092197,
  west: 123.426716,
};

export const mapOptions: google.maps.MapOptions = {
  restriction: { latLngBounds: restrictionBounds },
  fullscreenControl: false,
  backgroundColor: grey[200],
  clickableIcons: false,
  styles: [
    {
      featureType: 'all',
      stylers: [{ saturation: -30 }],
    },
    { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
    {
      featureType: 'landscape.man_made',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
  ],
};

interface Props {
  boxes: Box[];
  boxBounds: google.maps.LatLngBounds;
}

const Map = ({ boxes, boxBounds }: Props) => {
  return (
    <>
      <GoogleMap options={mapOptions}>
        <MapContent boxes={boxes} boxBounds={boxBounds} />
      </GoogleMap>
    </>
  );
};

export default Map;
